import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-td-value',
    templateUrl: './table-data-item.component.html',
    styleUrls: ['./table-data-item.component.scss'],
    standalone: false
})
export class TableDataItemComponent {

  @Input('type') input_type:string="text";
  @Input('value') input_value:any;
  @Input('copyToClipboard') input_copyToClipboard:boolean=false;
  @Input('lang') input_lang:string="";

  constructor() { }


}
